import { gql } from '@apollo/client';

import assetFields from '../fragments/assetFields';
import listingFields from '../fragments/listingFields';

const accountAssetByAccountQuery = gql`
  ${assetFields}
  ${listingFields}
  query AccountAssets($addresses: [String]) {
    accountAssets(where: { quantity_gt: 0, account_in: $addresses }) {
      id
      account {
        id
        address
        numAssets
      }
      asset {
        ...AssetField
        activeListings(orderBy: startTime, orderDirection: desc) {
          ...ListingField
        }
      }
    }
  }
`;

export default accountAssetByAccountQuery;
